import { joinSearchQuery } from '../../../libs/queryString';
import type { RouteLocation } from './createRoute';

export function isLocationsSame(first: RouteLocation, second: RouteLocation) {
  return first.pathname === second.pathname && joinSearchQuery(first.search) === joinSearchQuery(second.search);
}
